import React from 'react';

const ColorSelectSample = ({ color, border = null }) => {
  return (
    <div
      style={{
        borderRadius: '50%',
        boxSizing: 'border-box',
        backgroundColor: color,
        border: border,
        height: '1.2rem',
        width: '1.2rem',
      }}
    ></div>
  );
};

export default ColorSelectSample;
